module.exports = __webpack_public_path__ + "img/userA12.3f329626.jpg";